import PropTypes from 'prop-types';

import { TrlSectionTitle } from '../TrlSectionTitle';
import {
  HeaderContainer,
  SectionContainer,
} from './TrlDashboardMobileSection.styles';

export const TrlDashboardMobileSection = ({
  componentId,
  children,
  title,
  componentOrder,
  noParentSidePadding,
  rightSideComponent,
}) => (
  <SectionContainer
    id={componentId}
    componentOrder={componentOrder}
    noSidePadding={noParentSidePadding}
  >
    <HeaderContainer extraSidePadding={noParentSidePadding}>
      <TrlSectionTitle title={title} noBorderBottom noPaddingBottom />
      {rightSideComponent}
    </HeaderContainer>
    {children}
  </SectionContainer>
);

TrlDashboardMobileSection.propTypes = {
  componentId: PropTypes.string,
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  componentOrder: PropTypes.number,
  noParentSidePadding: PropTypes.bool,
  rightSideComponent: PropTypes.element,
};
